import { PaginationState, SortingState } from '@tanstack/react-table';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';

import { DataTableFilter } from '../utils/typings';

export const useCrud = <T extends DataTableFilter[]>({
  PAGE_SIZE = 20,
  defaultSort = [],
}: { PAGE_SIZE?: number; defaultSort?: SortingState } = {}) => {
  const [query, setQuery] = useState('');
  const [filters, setFilters] = useState<T[number][]>([]);
  const [sorting, setSorting] = useState<SortingState>(defaultSort);
  const [{ pageIndex, pageSize }, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });

  useEffect(() => {
    setPagination({ pageIndex: 0, pageSize: PAGE_SIZE });
  }, [PAGE_SIZE, query]);

  const handleQueryChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize],
  );

  const take = pageSize;
  const skip = take * pageIndex;

  return {
    query,
    handleQueryChange,
    filters,
    setFilters,
    sorting,
    setSorting,
    pagination,
    setPagination,
    take,
    skip,
  };
};
